export const Validations = {
  username: {
    regex: new RegExp(/^(?!^[0-9]*$)[a-zA-Z0-9_]{3,15}$/),
  },
  password: {
    regex: new RegExp(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/),
  },
  email: {
    regex: new RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/),
  },
  mobile: {
    regex: new RegExp("^[6789]\\d{9}$"),
  },
  fullName: {
    regex: new RegExp("^[a-zA-Z][a-zA-Z\\s]+$"),
  },
  bankAccount: {
    beneficiaryName: {
      regex: new RegExp(/^[a-zA-Z\s]{1,30}$/),
    },
    accountNumber: {
      regex: new RegExp(/^\d{9,18}$/),
    },
    branchName: {
      regex: new RegExp(/^[a-zA-Z0-9\s]+$/),
    },
    ifsc: {
      regex: new RegExp(/^[A-Z]{4}0[A-Z0-9]{6}$/),
      maxLength: 11,
    },
  },
};